import { CompletionStatus } from '../../../../../enums';

export function getStatusColour(completionStatus: CompletionStatus): string {
  switch (completionStatus) {
    case CompletionStatus.Completed:
      return 'var(--g)';
    case CompletionStatus.InProgress:
      return 'var(--a)';
    case CompletionStatus.NotStarted:
      return 'var(--borders)';
    default:
      return 'var(--default)';
  }
}
